import { GlSkeletonLoader } from '@gitlab/ui';
export default {
    name: 'AdditionalMetadataLoader',
    components: {
        GlSkeletonLoader
    },
    loader: {
        width: 302,
        height: 16,
        repeat: 2
    }
};
